<template>
  <span>
    <div>
      <span v-if="loading">Loading content. Please wait.</span>
      <div
        v-else
        class="body"
      >

        <div class="loaded">

          <div class="dg flex flex-column">
            <div class="dg flex justify-content-between">
              <div class="dg text text-heading">Details</div>
              <i
                class="fal fa-times exit"
                @click="close"
              />
            </div>

            <div class="info dg text">
              Originally posted in
              <a
                v-if="originalRally"
                class="link-button"
                :href="originalRallyPath"
              >{{
                originalRally.rally.attributes.title }}</a>
              by {{ originalMessageCreatorFirstName }} {{ originalMessageCreatorLastName }} on {{
                doFormatDate(ownerSharedDate) }}
            </div>
          </div>

          <div
            class="heading dg text-bold"
            style="margin: 3rem 0 0; font-size: 24px; font-weight: 700;"
          >Shared or Published to:</div>
          <div
            v-if="nonOwnerShares && nonOwnerShares.length > 0"
            class="info"
          >
            <div>
              <div v-if="sharesFetched">
                <table class="simple-table dg text">
                  <thead>
                    <tr class="dg text muted">
                      <th>By</th>
                      <th>To</th>
                      <th>On</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="s in nonOwnerShares"
                      :key="s.id"
                      class="dg border-bottom-gray"
                    >
                      <td>{{ getShareCreatorUser(s).attributes['first-name'] }} {{
                        getShareCreatorUser(s).attributes['last-name'] }}</td>
                      <td>
                        <a
                          class="link-button"
                          :href="getShareRallyPath(s)"
                        >{{ getShareRally(s) ?
                          getShareRally(s).attributes.title : '...' }}</a>
                      </td>
                      <td>{{ doFormatDate(getSharedDate(s)) }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            v-else
            class="info"
            style="font-style: italic; padding-top: 1rem;"
          >
            This has not been shared outside of this Rally.
          </div>
        </div>
        <div class="actions">
          <div class="footer">
            <button
              class="dg primary"
              type="button"
              style="min-width: 12rem;"
              @click="openOriginal"
            >
              Open Original
            </button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { eventBus } from "@/main.js";
import moment from "moment-timezone";
export default {

  // props: ["content", "rallyId", "channelId"],
  props: {
    content: {
      type: Object,
      required: true,
    },
    rallyId: {
      type: Number,
      required: true,
    },
    channelId: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      modalStatus: false,
      // isLoading: true,
      ralliesSharedTo: {},
      shared: false,
      sharesFetched: false,
      loading: false,
    };
  },
  computed: {
    ...mapState("shares", ["sharesByContentId"]),
    ...mapState("contents", ["contentById"]),
    ...mapState("rallies", ["allRalliesByRallyId"]),
    ...mapState("user", ["status", "user", "usersById"]),
    originalMessageCreatorUser() {
      return this.usersById[parseInt(this.contentById[parseInt(this.ownerShares[0].attributes['content-uid'])].attributes['creator-id'])]
    },
    originalMessageCreatorFirstName() {
      if (!this.ownerShares || this.ownerShares.length == 0 || !this.originalMessageCreatorUser) {
        return "";
      }
      return this.originalMessageCreatorUser.attributes['first-name']
    },
    originalMessageCreatorLastName() {
      if (!this.ownerShares || this.ownerShares.length == 0 || !this.originalMessageCreatorUser) {
        return "";
      }
      return this.originalMessageCreatorUser.attributes['last-name']
    },
    isLoading() {
      return (this.ownerShares && this.ownerShares.length > 0 && this.originalRally && this.originalRally.rally)
    },
    originalRallyPath() {
      console.log(this.originalRally.id, " this.originalRally.id")
      return '/rallies/' + this.originalRally.id
      // return '/' + this.originalRally.id + '/messages'
    },
    originalRally() {
      return this?.allRalliesByRallyId[parseInt(this.ownerShares[0]?.attributes['context-rally-id'])]
    },
    ownerSharedDate() {
      if (!this.ownerShares || this.ownerShares.length == 0) {
        return "";
      }
      return this.ownerShares[0].attributes['created-at']
    },

    ownerShares() {
      return this.contentShares ? this.contentShares.filter(function (s) { return s.attributes['share-type'] == 'original' }) : []
    },
    nonOwnerShares() {
      return this.contentShares ? this.contentShares.filter(function (s) { return s.attributes['share-type'] !== 'original' }) : []
    },
    contentShares() {
      return this.sharesByContentId[parseInt(this.content.id)]
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapActions("shares", ["fetchSharesByContentId", "shareContent", "clearContentShareState"]),
    ...mapActions("rallies_v2", ["fetchRallies"]),
    ...mapActions("user", ["setModalProps"]),
    close() {
      this.setModalProps({})
      this.clearContentShareState();
    },
    openOriginal() {
      eventBus.emit('openOriginalContent', this.content);
      this.close();
    },
    getShareCreatorUser(s) {
      if (!this.usersById[parseInt(this.contentById[parseInt(s.attributes['content-uid'])].attributes['creator-id'])]) {
        return { attributes: { 'first-name': 'Unknown', 'last-name': 'User' } }
      }
      return this.usersById[parseInt(this.contentById[parseInt(s.attributes['content-uid'])].attributes['creator-id'])]
    },
    getShareRally(s) {
      return this.ralliesSharedTo[parseInt(s.attributes['context-rally-id'])]
    },
    getSharedDate(s) {
      return s.attributes['created-at']
    },
    getShareRallyPath(rally) {
      const r = this.getShareRally(rally)
      return r ? '/' + r.id : '#'
    },
    doFormatDate(time) {
      return moment(time).format("MMMM, DD YYYY");
    },
    async fetchData() {
      this.loading = true
      await this.fetchSharesByContentId({ contentId: this.content.id, contextRallyId: this.rallyId, contextChannelId: this.channelId })
      // --- Get the context-rally-ids from the shares
      let shares = this.sharesByContentId[this.content.id] || [];
      let contextRallyIds = shares.map(share => share.attributes['context-rally-id']);

      let ralliesSharedToArray = await this.fetchRallies({ rallyIds: contextRallyIds, pageSize: contextRallyIds.length })

      this.ralliesSharedTo = ralliesSharedToArray.reduce((acc, rally) => {
        acc[rally.id] = rally;
        return acc;
      }, {});

      this.sharesFetched = true;
      this.loading = false
      this.modalStatus = true;
    }
  }
}
</script>
